import React from 'react';
export interface DividerProps {
  orientation?: 'horizontal' | 'vertical';
  className?: string;
  'data-id'?: string;
}
export function Divider({
  orientation = 'horizontal',
  className = '',
  'data-id': dataId
}: DividerProps) {
  if (orientation === 'vertical') {
    return <div className={`w-px bg-[#CBD5E1] ${className}`} data-id="element-3286"></div>;
  }
  return <hr className={`border-0 border-t border-[#CBD5E1] ${className}`} data-id="element-3287" />;
}